import DealerErrorsFactory from '../Errors/factory.js'
import {ContractEntity} from './ContractEntity.js'
import {DealerEntity} from './DealerEntity.js'
import {PackEntity} from './PackEntity.js'

export default class DealerEntitiesFactory {
  /**
   * @method
   * @return {ContractEntity}
   */
  static contractEntity = ({id, isPrivate, isProfessional} = {}) => {
    ContractEntity.validate({
      id,
      invalidContractErrorFactory: DealerErrorsFactory.contractError
    })
    return new ContractEntity({
      id,
      isPrivate,
      isProfessional
    })
  }

  /**
   * @method
   * @return {DealerEntity}
   */
  static dealerEntity = ({
    allowOnlineAppointment,
    brandingActive,
    showContactLogo,
    showDealerDirections,
    externalContractId,
    externalPageUrl,
    groupName,
    hasCallTrackingService,
    hasFinancingProduct,
    hasReservation,
    hasWhatsappProduct,
    hidePhone,
    id,
    isRecommended,
    location,
    logoImageUrl,
    mainRentingServicesIncluded,
    moreInformation,
    name,
    pack,
    phoneNumber,
    ratings,
    relatedStores,
    schedule,
    sellerMessagingId,
    services,
    isActive,
    predictionScore,
    stockPageUrl,
    storeImageUrls,
    totalPublishedVehicles,
    type,
    videos = []
  } = {}) => {
    DealerEntity.validate({
      id,
      invalidDealerErrorFactory: DealerErrorsFactory.dealerError
    })

    return new DealerEntity({
      allowOnlineAppointment,
      brandingActive,
      showContactLogo,
      showDealerDirections,
      externalContractId,
      externalPageUrl,
      groupName,
      hasCallTrackingService,
      hasFinancingProduct,
      hasReservation,
      hasWhatsappProduct,
      hidePhone,
      id,
      isRecommended,
      location,
      logoImageUrl,
      mainRentingServicesIncluded,
      moreInformation,
      name,
      pack,
      phoneNumber,
      ratings,
      relatedStores,
      sellerMessagingId,
      schedule,
      services,
      stockPageUrl,
      storeImageUrls,
      isActive,
      predictionScore,
      totalPublishedVehicles,
      type,
      videos
    })
  }

  static packEntity = ({legacyId, type}) => new PackEntity({legacyId, type})
}
